import {Link} from "react-router-dom";

export const SettlementDeals = ({
                                    company,
                                    company_other,
                                    settlement_other,
                                    bullstat,
                                    amount,
                                    settlement_ekatte,
                                    year
                                }) => {
    return (
        <tr>
            <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                      to={`/info/${year}/${settlement_ekatte}/${bullstat}`}>{company.company_name}</Link></td>
            <td><Link style={{color: "var(--app-gold)", textDecoration: "none"}}
                      to={`/info/${year}/${settlement_ekatte}/${company_other.bullstat}`}>{company_other.company_name}</Link>
            </td>
            <td>{settlement_other.settlement}</td>
            <td>{amount?.toFixed(2)}</td>
        </tr>
    )
}